const routes = [
  {
    path: "/feedback/mobile-app-rating",
    component: () => import(/* webpackChunkName: "mobileAppRating" */ "./views/MobileAppRating")
  }
];
export default routes;
